<!-- =========================================================================================
  File Name: FormSidebar
  Description: For adding or edditing user information
  ----------------------------------------------------------------------------------------
  Item Name: JogjaBagus Backoffice
  Author: Hifi Saputra
  Author Email: hifisaputra1@gmail.com
  Author URL: https://github.com/fei77
========================================================================================== -->

<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ formTitle }}</h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>

    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar
      class="scroll-area--data-list-add-new pb-6"
      :settings="settings"
    >
      <div
        class="p-6 vs-con-loading__container"
        id="form-sidebar"
      >

        <select-status
          :data="formData.status"
          @change="formData.status = $event"
        />

        <select-member
          class="mt-3"
          :data="formData.owner"
          @change="formData.owner = $event"
        />

        <select-marketing
          class="mt-3"
          :data="formData.author"
          @change="formData.author = $event"
        />

        <select-business class="pt-5" label="Business" :data="formData.business" @change="onSelect" />

        <select-category
          :data="formData.category"
          @change="formData.category = $event"
        />

        <vs-checkbox class="mt-1" v-model="formData.showOnMainPage">Show list on the home page</vs-checkbox>

        <vs-divider class="my-10">
          Deal
        </vs-divider>

        <div class="flex flex-end">
          <date-input
            :data="formData.dateRegister"
            @change="formData.dateRegister = $event"
            class="mr-3"
          />

          <vs-input-number v-model="formData.price" />
        </div>

        <vs-divider class="my-10">
          Renewal
        </vs-divider>

        <div class="flex flex-end">
          <date-input
            :data="formData.dateRenewal"
            @change="formData.dateRenewal = $event"
            class="mr-3"
          />

          <vs-input-number v-model="formData.priceRenewal" />
        </div>

        <select-billing-cycle
          class="mt-5"
          :data="formData.billingCycle"
          @change="formData.billingCycle = $event"
        />

        <vs-divider class="my-10">
          Order
        </vs-divider>
        <vs-input-number v-model="formData.order" />
      </div>
    </VuePerfectScrollbar>

    <div
      class="flex flex-wrap items-center justify-center p-6"
      slot="footer"
    >
      <vs-button
        class="mr-6"
        @click="submit"
      >Save</vs-button>

      <vs-button
        type="border"
        color="danger"
        @click="isSidebarActiveLocal = false"
      >Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import _ from 'lodash'
export default {
  props: {
    itemId: {
      type: String,
      default: null
    },
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    formTitle: {
      type: String,
      required: true
    },
    formData: {
      type: Object,
      default: () => {
        return {
          business: ''
        };
      }
    }
  },
  data () {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      loading: false,
      data: {}
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive;
      },
      set (val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    },
    validate () {
      return (this.formData.business)
    }
  },
  methods: {
    onSelect(val) {
      this.$emit('change', _.pick(val, [
        'id',
        'name',
        'slug',
        'logoUrl',
        'thumbnailUrl',
        'category',
        'email',
        'phone',
        'address',
        'socmedLink',
        'contractNumber',
        'excerptEn',
        'excerptId',
        'titleId',
        'titleEn'
      ]))
    },
    submit () {
      if (!this.validate) return false
      if (this.itemId) {
        this.updateItem();
      } else {
        this.createItem();
      }
    },
    updateItem () {
      this.$vs.loading();

      this.$store.dispatch('toplist/patch', this.formData)
        .then(() => {
          this.notifySuccess('Data updated')
          this.closeSidebar()
        })
        .catch(err => {
          this.notifySuccess(err.message)
        })
        .then(() => this.$vs.loading.close())
    },
    createItem () {
      this.$vs.loading();

      this.$store.dispatch('toplist/insert', this.formData)
        .then(() => {
          this.notifySuccess('Data created')
          this.closeSidebar()
        })
        .catch(err => {
          this.notifySuccess(err.message)
        })
        .then(() => this.$vs.loading.close())
    },
    closeSidebar () {
      this.$emit("closeSidebar")
    }
  }
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  /deep/ .vs-sidebar--background {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  height: calc(100% - 4.3rem);
}
</style>
